$(function() {
    'use strict';

    if ($('.media-testimonial').length) {
        // * Change Slick options
        $('.media-testimonial .slick-slider').slick({
            arrows: false,
            dots: true,
            appendDots: $('.orbit-bullets')
        });

        // * Change image on slide change
        $('.media-testimonial').on('afterChange', function(event, slick, currentSlide, nextSlide) {
            $('.media-testimonial .carousel--images').children().removeClass('is-active');
            $('.media-testimonial .carousel--images').find("[data-slide='" + currentSlide + "']").addClass('is-active');
        });

        // * Go to previous slide
        $('.media-testimonial .orbit-previous').on('click touchstart', function() {
            $('.media-testimonial .slick-slider').slick('slickPrev');
        });

        // * Go to next slide
        $('.media-testimonial .orbit-next').on('click touchstart', function() {
            $('.media-testimonial .slick-slider').slick('slickNext');
        });
    }
});
